module.exports = "\n<i class=\"fa fa-chevron-up\" *ngIf=\"sortDirection === 'asc'\" ></i>\n<i class=\"fa fa-chevron-down\" *ngIf=\"sortDirection === 'desc'\"></i>\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// /home/sotsys211/work/src/ecard_new/backend/src/app/sortable-table/sortable-column.component.html
// module id = ../../../../../src/app/sortable-table/sortable-column.component.html
// module chunks = main